import React from 'react';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import { useMenu } from '../auth/useMenu';
import { Alert, Container } from 'react-bootstrap';

interface ProtectedRouteProps {
  children: React.ReactNode;
  /** Menu key to check, e.g. 'scouting:fieldMode' or 'module:scouting'. */
  menuKey: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, menuKey }) => {
  const { t } = useTranslation();
  const { user, loading } = useAuth();
  const hasAccess = useMenu(menuKey);

  if (loading) {
    return null; // App.tsx already handles the main loading spinner
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (hasAccess) {
    return <>{children}</>;
  }

  return (
    <Container className="mt-5">
      <Alert variant="danger">
        <Alert.Heading>{t('protectedRoute.accessDenied')}</Alert.Heading>
        <p>{t('protectedRoute.noModulePermission', { subject: menuKey })}</p>
        <p className="small mb-0">
          {t('protectedRoute.contactAdmin')}
        </p>
      </Alert>
    </Container>
  );
};

export default ProtectedRoute;
